export const onUpdatePortfolioStatus = /* GraphQL */ `
  subscription onUpdatePortfolioStatus($owner: String!, $id: ID) {
    onUpdatePortfolio(owner: $owner, id: $id) {
      id
      cash
      updatedAt
      status {
        calculationStatus
        calculationMessage
        addedCashAmount
      }
    }
  }
`

export const onUpdatePortfolioRealTimeChange = /* GraphQL */ `
subscription onUpdatePortfolioRealTimeChange($owner: String!, $id: ID) {
  onUpdatePortfolioRealTimeChange(owner: $owner, id: $id) {
    id
  }
}`

export const watchlistDetailsInstrumentSubscription = /* GraphQL */ `
  subscription onCreateRealTimePrice($id: ID!) {
    onCreateRealTimePrice(id: $id) {
      id
      price
      priceChange
      priceChangePercentage
      high
      low
      timestamp
    }
  }
`

export const watchlistDetailsWLEntrySubscription = /* GraphQL */ `
  subscription onUpdateWatchlistEntry($owner: String!, $id: ID!) {
    onUpdateWatchlistEntry(owner: $owner, watchlistId: $id) {
      alertActive
      instrumentId
      lowerLimit
      upperLimit
      exceeded {
        lowerLimit
        price
        timestamp
        upperLimit
      }
    }
  }
`

export const watchlistLimitsInstrumentSubscription = /* GraphQL */ `
  subscription onCreateRealTimePrice($id: ID!) {
    onCreateRealTimePrice(id: $id) {
      id
      price
      timestamp
    }
  }
`

export const myHubWatchlistInstrumentSubscription = /* GraphQL */ `
  subscription onCreateRealTimePrice($id: ID!) {
    onCreateRealTimePrice(id: $id) {
      id
      price
      timestamp
      quality
    }
  }
`

export const speakerMessageSubscription = /* GraphQL */ `
  subscription onSpeakerMessageRecipient($owner: String!) {
    onSpeakerMessageRecipient(owner: $owner) {
      id
      owner
      createdAt
      receivedAt
      readAt
      status
      message {
        id
        broadcastMessage
        type
        title
        text
        status
        createdAt
      }
    }
  }
`

export const strategyDetailsInstrumentSubscription = /* GraphQL */ `
  subscription onCreateRealTimePrice($id: ID!) {
    onCreateRealTimePrice(id: $id) {
      id
      price
      priceChange
      priceChangePercentage
      high
      low
      timestamp
    }
  }
`

export const companyDetailsSubscription = /* GraphQL */ `
  subscription onCreateRealTimePrice($id: ID!) {
    onCreateRealTimePrice(id: $id) {
      id
      price
      timestamp
      high
      low
      exchangeName
    }
  }
`


export const indexSubscription = /* GraphQL */ `
  subscription onCreateRealTimePrice($id: ID!) {
    onCreateRealTimePrice(id: $id) {
      id
      price
      timestamp
    }
  }
`


export const onUpdateSystemStatus = /* GraphQL */ `
  subscription OnUpdateSystemStatus($id: ID!) {
    onUpdateSystemStatus(id: $id) {
      id
      status
    }
  }
`
